var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Col } from '@amzn/atoz-web/Col';
import { H1, H2 } from '@amzn/atoz-web/Text';
import { ErrorPerson } from '../../features/shared/Icons/ErrorPerson/ErrorPerson.web';
export var GenericErrorContent = function (_a) {
    var onButtonClick = _a.onButtonClick, buttonText = _a.buttonText, titleText = _a.titleText, _b = _a.textAlign, textAlign = _b === void 0 ? 'left' : _b, bodyText = _a.bodyText;
    var t = useTranslation().t;
    var titleString = titleText || t('ess_error_wrapper_message');
    var bodyString = bodyText || t('ess_error_wrapper_try_again');
    var buttonString = buttonText || t('ess_shifts_dashboard_errorModal_tryAgain');
    return (React.createElement(Col, { dataTestId: "GenericErrorContent" },
        React.createElement(H1, { fontSize: "T600", textAlign: textAlign }, titleString),
        React.createElement(H2, { fontSize: "T400", textAlign: textAlign, margin: { bottom: 'S600' } }, bodyString),
        React.createElement(ErrorPerson, { className: "GenericErrorPage__image", alt: t('ess_error_wrapper_img_alt') }),
        React.createElement(StyledButton, { variant: ButtonVariant.Primary, onClick: onButtonClick || window.location.reload, dataTestId: "GenericErrorContentButton" }, buttonString)));
};
var StyledButton = styledWithTheme(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", "px;\n"], ["\n    margin-top: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.selectors.space('S600');
});
var templateObject_1;
